function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M16.19 2H7.82C4.18 2 2.01 4.17 2.01 7.81v8.37c0 3.64 2.17 5.81 5.81 5.81h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.92 9.28l.05 2.95 2.63-.04c.19 0 .33.17.3.35l-.35 1.91c-.03.14-.15.24-.29.25l-2.25.04.12 7.25-3 .05-.12-7.25-1.7.03c-.17 0-.3-.13-.3-.3l-.03-1.9c0-.17.13-.3.3-.3l1.7-.03-.05-3.25a2.996 2.996 0 012.95-3.05l2.7-.04c.17 0 .3.13.3.3l.04 2.4c0 .17-.13.3-.3.3l-2.4.04c-.17-.01-.3.13-.3.29z"
})));